import axios from "axios";
import { env } from "../config/env";

//form api
const _API = axios.create({ baseURL: env.API_ENDPOINT_URL });
const API_KEY = env.API_ENDPOINT_KEY;

_API.interceptors.request.use((req) => {
    req.headers['x-api-key'] = API_KEY;
    return req;
});

//upload api
const ATTACHMENT_API = axios.create({ baseURL: env.IMAGE_ENDPOINT_URL });
const ATTACHMENT_API_KEY = env.IMAGE_ENDPOINT_KEY;

ATTACHMENT_API.interceptors.request.use((req) => {
    req.headers['x-api-key'] = ATTACHMENT_API_KEY;
    return req;
});

//form api
export const fetchFormById = (id) => _API.get(`/careadmin/resident-admission-form?customer_id=${id}`);
export const createForm = (newForm) => _API.post('/careadmin/resident-admission-form', newForm);
export const updateForm = (id, updatedForm) => _API.put(`/careadmin/resident-admission-form?id=${id}`, updatedForm);

//upload image api
export const getImage = (url) => ATTACHMENT_API.get(`/resident/attachment?url=${url}`);
export const uploadImage = (image) => ATTACHMENT_API.post('/resident/attachment', image);

// Define the base URL for your API services
// This should be set in your environment variables (e.g., .env file)
const apiRouting = {
  careadmin: _API,
  attachment: ATTACHMENT_API
}; // Use your API base URL from env

export const API = {
  get: async (serviceName, path) => {
    if(!apiRouting[serviceName]) {
      throw new Error(`Service ${serviceName} not configured in API base URLs.`);
    }
    return await apiRouting[serviceName].get(path);
  },

  post: async (serviceName, path, body) => {
    if(!apiRouting[serviceName]) {
      throw new Error(`Service ${serviceName} not configured in API base URLs.`);
    }
    return await apiRouting[serviceName].post(path, body);
  },

  put: async (serviceName, path, body) => {
    if(!apiRouting[serviceName]) {
      throw new Error(`Service ${serviceName} not configured in API base URLs.`);
    }
    return await apiRouting[serviceName].put(path, body);
  },
};

// Export the default API object